import { Form, SubmitButton, TextAreaInputField } from '@/components';
import { SsProjectOtherNotesFormSchema } from '@/features/project/projects/_models/project';
import { useForm } from '@/hooks';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

type FormValues = z.infer<typeof SsProjectOtherNotesFormSchema>;

type Props = {
  onSubmit: (value: FormValues) => void;
  initialValues: FormValues;
};

export const ProjectOtherNotesForm: FC<Props> = ({
  onSubmit,
  initialValues,
}) => {
  const { t } = useTranslation();

  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting, isDirty, isSubmitSuccessful },
  } = useForm<FormValues>({
    defaultValues: initialValues,
    resolver: zodResolver(SsProjectOtherNotesFormSchema),
  });

  return (
    <Form
      leavePageAlertCondition={{
        isDirty,
        isSubmitting,
        isSubmitSuccessful,
      }}
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
    >
      <TextAreaInputField
        name="otherSpecialNotes"
        label={t('other-special-notes')}
        control={control}
        errors={errors}
        rows={5}
      />
      <SubmitButton loading={isSubmitting} disabled={!isDirty} />
    </Form>
  );
};
